module.exports = __webpack_public_path__ + "23be85ba1dd348ba6ca34126e7042896.woff";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/GT-Walsheim-Pro-Regular.woff
// module id = 1244
// module chunks = 0